
<template>
  <el-select class="kye-date-picker2_year-select kye-date-picker2_month-select"
    v-model="curMonth"
    :popper-append-to-body="false"
    @change="handleMonthClick">
    <el-option
      v-for="item in currentMonths"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
  import { isDate } from '../utils'
  export default {
    props: {
      date: {},
      startDate: {},
      endDate: {},
    },
    watch: {
      date: {
        handler() {
          const _curMonth = this.date.getMonth()
          if (_curMonth !== this.curMonth) {
            this.curMonth = _curMonth
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'].map((month, index) => ({ label: month, value: index })),
        curMonth: ''
      }
    },
    computed: {
      currentMonths () {
        const dateYear = this.date.getFullYear()
        if (isDate(this.startDate)) {
          const val = this.startDate.getMonth()
          const year = this.startDate.getFullYear()
          return year !== dateYear ? this.months : this.months.slice(val)
        }
        if (isDate(this.endDate)) {
          const val = this.endDate.getMonth()
          const year = this.endDate.getFullYear()
          return year !== dateYear ? this.months : this.months.slice(0, val + 1)
        }
        return this.months
      }
    },
    methods: {
      getMonthOfCell(month) {
        const year = this.date.getFullYear()
        return new Date(year, month, 1)
      },
      handleMonthClick(month) {
        const newDate = this.getMonthOfCell(month)
        if (this.selectionMode === 'range') {
          if (!this.rangeState.selecting) {
            this.$emit('pick', {minDate: newDate, maxDate: null})
            this.rangeState.selecting = true
          } else {
            if (newDate >= this.minDate) {
              this.$emit('pick', {minDate: this.minDate, maxDate: newDate})
            } else {
              this.$emit('pick', {minDate: newDate, maxDate: this.minDate})
            }
            this.rangeState.selecting = false
          }
        } else {
          this.$emit('pick', month)
        }
      }
    }
  }
</script>

<style lang="scss">
.ky-erp .kye-date-picker2{
  &_year-select{
    width: 62px !important;
    .el-input{
      .el-input__inner{
        padding-right: 18px !important;
      }
      .el-input__suffix{
        display: flex;
        align-items: center;
        right: 8px;
        .el-icon-arrow-up {
          width: 8px;
          height: 5px;
          background-image: url("../images/arrow-up.png");
          background-size: 8px 5px;
          display: block;
          background-repeat: no-repeat;
          transform: rotateZ(0deg) !important;
          &::before{
            content: "" !important;
          }
        }
      }
    }
    .el-select-dropdown__wrap{
      max-height: 174px !important;
      .el-select-dropdown__item{
        padding-left: 8px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/basic/month-select.vue